<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">

        <div class="paper-header">
          <div class="paper-header-info">
            <p class="paper-name">{{ paperInfo.name }}</p>
            <p class="paper-meta">
              <span>课程：{{ paperInfo.courseFullName }}</span>
              <span>题量：{{ paperInfo.totalCount }}题</span>
            </p>
          </div>
          <a href="javascript:void(0);" class="redo-btn" @click="handleContinueOrRedo">{{ paperInfo.canContinue ? '继续练习' : '重新练习' }}</a>
        </div>

        <div class="dashboard-top">
          <div class="panel stats-panel">
            <p class="section-title"><span class="title-bar"></span>正确率趋势<span class="sub">（客观题）</span></p>
            <div class="metric-grid">
              <div class="metric-box blue">
                <p class="metric-label">练习次数</p>
                <p class="metric-value">{{ summaryData.practiceCount }}</p>
              </div>
              <div class="metric-box green">
                <p class="metric-label">最近正确率</p>
                <p class="metric-value">{{ summaryData.correctRate }}%</p>
              </div>
              <div class="metric-box orange">
                <p class="metric-label">平均正确率</p>
                <p class="metric-value">{{ summaryData.avgCorrectRate }}%</p>
              </div>
              <div class="metric-box red">
                <p class="metric-label">错题数量</p>
                <p class="metric-value">{{ summaryData.mistakeCount }}</p>
              </div>
            </div>
            <div class="entry-row">
              <div class="entry-card wrong-entry" @click="openWrongModal">
                <div class="entry-text">
                  <p class="entry-title">
                    <span>错题集</span>
                    <img src="@/assets/right_red.png" alt="" class="entry-arrow" />
                  </p>
                  <p class="entry-sub">共 <span class="red">{{ summaryData.wrongCount }}</span> 题</p>
                </div>
                <img src="@/assets/ctj.png" alt="" class="entry-img" />
              </div>
              <div class="entry-card fav-entry" @click="openFavModal">
                <div class="entry-text">
                  <p class="entry-title">
                    <span>收藏夹</span>
                    <img src="@/assets/right_orange.png" alt="" class="entry-arrow" />

                  </p>
                  <p class="entry-sub">共 <span class="orange">{{ summaryData.favCount }}</span> 题</p>
                </div>
                <img src="@/assets/scj.png" alt="" class="entry-img" />
              </div>
            </div>
          </div>

          <div class="panel chart-panel">
            <p class="section-title"><span class="title-bar"></span>正确率趋势<span class="sub">（客观题）</span></p>
            <div class="trend-chart" ref="trendChart"></div>
          </div>
        </div>

        <div class="panel record-panel">
          <div class="record-list-header">
            <p class="section-title"><span class="title-bar"></span>练习记录</p>
            <p class="subtitle">共{{ recordList.length }}次练习记录，点击可查看答题详情</p>
          </div>
          <div class="record-list-body">
            <div
              class="record-item"
              v-for="(record, idx) in recordList"
              :key="record.id"
              @click="openReview(record)"
            >
              <div class="record-main">
                <p class="record-datetime">{{ record.date }} {{ record.time }}</p>
                <div class="record-stats">
                  <span>正确率：<span class="val" :class="rateColorClass(record.correctRate)">{{ record.correctRate }}%</span></span>
                  <span>总题：{{ recordTotal(record) }}</span>
                  <span>答对：{{ record.correctCount }}题</span>
                  <span>答错：{{ record.wrongCount }}题</span>
                  <span>答题用时：{{ formatDuration(record.duration) }}分钟</span>
                </div>
              </div>
              <div class="record-action">
                <button class="action-btn" @click.stop="openReview(record)">详情</button>
                <button class="action-btn delete" @click.stop="deleteRecord(record, idx)">删除</button>
              </div>
            </div>
          </div>
          <div class="empty-state" v-if="recordList.length === 0">
            <el-empty description="暂无练习记录" />
          </div>
        </div>
    </div>
    <div class="custom-modal-mask" v-if="reviewVisible" @click.self="reviewVisible = false">
      <div class="custom-modal review-dialog" style="width: 1100px;">
        <div class="custom-modal-header">
          <span class="modal-title">练习记录 - {{ reviewRecord.date }} {{ reviewRecord.time }}</span>
          <span class="custom-modal-close" @click="reviewVisible = false">&times;</span>
        </div>
        <div class="custom-modal-body">
          <div class="review-stats">
            <div class="review-stat">
              <div class="stat-value correct">{{ reviewRecord.correctRate }}%</div>
              <div class="stat-label">客观题正确率</div>
            </div>
            <div class="review-stat">
              <div class="stat-value correct">{{ reviewRecord.correctCount }}</div>
              <div class="stat-label">客观题答对</div>
            </div>
            <div class="review-stat">
              <div class="stat-value wrong">{{ reviewRecord.wrongCount }}</div>
              <div class="stat-label">客观题答错</div>
            </div>
            <div class="review-stat">
              <div class="stat-value">{{ formatDuration(reviewRecord.duration) }}分钟</div>
              <div class="stat-label">用时</div>
            </div>
          </div>
          <div class="review-questions">
            <div class="review-main">
              <div v-for="(section, si) in reviewSections" :key="si" class="question-card">
                <div class="q-section-title">
                  <span v-html="sectionTitle(section, si)"></span>
                </div>
                <div v-for="q in section.questions" :key="q.id" class="q-item" :ref="'reviewQ_' + q.globalIndex">
                  <p class="q-num-tag">{{ q.globalIndex }}. <span v-html="q.content"></span></p>
                  <ul class="q-options" v-if="q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'">
                    <template v-if="q.type === 'JUDGMENT'">
                      <li :class="getReviewOptionClass(q, 'Y')"><span class="radio"></span>A. 正确</li>
                      <li :class="getReviewOptionClass(q, 'N')"><span class="radio"></span>B. 错误</li>
                    </template>
                    <template v-else>
                      <li v-for="(opt, oi) in q.options" :key="oi" :class="getReviewOptionClass(q, opt.alisa)">
                        <span class="radio"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
                      </li>
                    </template>
                  </ul>
                  <div class="analysis-box">
                    <p class="label">解析</p>
                    <template v-if="q.type === 'BLANKFILL'">
                      <p class="answer blank-row" v-for="(row, ri) in getBlankRows(q)" :key="ri">
                        第{{ ri + 1 }}空：正确答案 <b v-html="row.correct"></b>，你的答案 <b :class="{ 'text-correct': row.isCorrect, 'text-wrong': !row.isCorrect }">{{ row.user || '未作答' }}</b>
                      </p>
                    </template>
                    <template v-else-if="q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'">
                      <p class="answer">
                        正确答案：{{ q.type === 'JUDGMENT' ? (q.answer === 'Y' ? '正确' : '错误') : q.answer }}
                      </p>
                      <p class="answer wrong-answer">
                        你的答案：{{ formatUserAnswer(q) }} {{ q.isCorrect ? '✓' : '✗' }}
                      </p>
                    </template>
                    <template v-else>
                      <div class="answer-box d-flex d-flex-top mb10">
                        <p class="answer">正确答案：</p>
                        <p class="detail answer-html" v-if="q.answer || q.key"><span v-html="reformHtml(q.answer || q.key)"></span></p>
                      </div>
                      <div class="answer-box d-flex d-flex-top mb10">
                        <p class="answer wrong-answer" v-if="hasUserAnswer(q)">你的答案：</p>
                        <p class="detail answer-html" v-if="hasUserAnswer(q)"><span v-html="reformHtml(formatUserAnswer(q))"></span></p>
                        <p class="answer wrong-answer" v-else>你的答案：未作答</p>
                      </div>
                    </template>
                    <p class="detail" v-if="q.analysis"><span v-html="q.analysis"></span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="review-sidebar">
              <div class="review-card">
                <p class="card-title">答题卡</p>
                <div class="review-grid">
                  <span
                    v-for="(q, idx) in reviewFlatQuestions"
                    :key="idx"
                    class="num"
                    :class="{
                      correct: q.isCorrect,
                      wrong: !q.isCorrect && (q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'),
                      answered: (q.type === 'ESSAY' || q.type === 'BLANKFILL') && hasUserAnswer(q),
                      current: idx === reviewCurrentIdx
                    }"
                    @click="goReviewQuestion(idx)"
                  >{{ idx + 1 }}</span>
                </div>
                <div class="review-legend">
                  <span><span class="dot correct"></span> 正确</span>
                  <span><span class="dot wrong"></span> 错误</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <WrongModal :visible.sync="wrongVisible" :courseId="courseId" :paperId="paperId" @deleted="getSummary" />
    <FavModal :visible.sync="favVisible" :courseId="courseId" :paperId="paperId" @deleted="getSummary" />
  </div>
</template>

<script>
import { quesMap, sectionTitle as _sectionTitle } from "@/utils/enums";
import * as echarts from "echarts";
import WrongModal from "./components/WrongModal.vue";
import FavModal from "./components/FavModal.vue";

export default {
  name: "freeStudyPaperResult",
  components: { WrongModal, FavModal },
  data() {
    return {
      paperId: '',
      courseId: '',
      paperInfo: {},
      summaryData: {
        practiceCount: 0,
        correctRate: 0,
        avgCorrectRate: 0,
        mistakeCount: 0,
        wrongCount: 0,
        favCount: 0,
      },
      trendList: [],
      trendChart: null,
      recordList: [],
      quesMap,
      reviewVisible: false,
      reviewRecord: {},
      reviewSections: [],
      reviewCurrentIdx: 0,
      wrongVisible: false,
      favVisible: false,
      pageLoading: false,
    };
  },
  computed: {
    reviewFlatQuestions() {
      const list = [];
      this.reviewSections.forEach(s => { s.questions.forEach(q => list.push(q)); });
      return list;
    },
  },
  created() {
    this.paperId = this.$route.query.paperId;
    this.courseId = this.$route.query.courseId;
    if (!this.paperId || !this.courseId) {
      this.$message.warning('参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getSummary();
    this.getTrend();
    this.getRecordList();
  },
  mounted() {
    this.initTrendChart();
  },
  beforeDestroy() {
    if (this.trendChart) {
      this.trendChart.dispose();
      this.trendChart = null;
    }
  },
  methods: {
    getSummary() {
      this.pageLoading = true;
      this.$http.get('/student/pc/freeStudy/paperResultSummary', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        this.paperInfo = res.paperInfo || {};
        this.summaryData = {
          practiceCount: res.practiceCount || 0,
          correctRate: res.correctRate || 0,
          avgCorrectRate: res.avgCorrectRate || 0,
          mistakeCount: res.mistakeCount ?? res.wrongQuestionCount ?? 0,
          wrongCount: res.wrongCount || 0,
          favCount: res.favCount || 0,
        };
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    getTrend() {
      this.$http.get('/student/pc/freeStudy/paperResultTrend', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        this.trendList = res || [];
        this.$nextTick(() => this.initTrendChart());
      });
    },
    getRecordList() {
      this.$http.get('/student/pc/freeStudy/paperRecordList', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        this.recordList = res || [];
      });
    },
    initTrendChart() {
      const el = this.$refs.trendChart;
      if (!el || this.trendList.length === 0) return;
      if (this.trendChart) this.trendChart.dispose();
      const chart = echarts.init(el);
      this.trendChart = chart;
      const labels = this.trendList.map(i => i.label);
      const data = this.trendList.map(i => i.rate);
      const needScroll = this.trendList.length > 8;
      chart.setOption({
        grid: { top: 20, right: 20, bottom: needScroll ? 40 : 30, left: 45 },
        xAxis: {
          type: 'category',
          data: labels,
          axisLine: { lineStyle: { color: '#e3e3e3' } },
          axisLabel: { color: '#999', fontSize: 11 },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          axisLabel: { color: '#999', fontSize: 11, formatter: '{value}%' },
          splitLine: { lineStyle: { color: '#f2f2f2' } },
        },
        dataZoom: needScroll ? [{
          type: 'slider',
          start: 0,
          end: Math.min(100, (8 / this.trendList.length) * 100),
          height: 16,
          bottom: 4,
          borderColor: '#e3e3e3',
          fillerColor: 'rgba(64, 158, 255, 0.1)',
          handleStyle: { color: '#409eff' },
          textStyle: { fontSize: 10, color: '#999' },
        }] : [],
        tooltip: {
          trigger: 'axis',
          formatter: params => `${params[0].axisValue}<br/>正确率：<b>${params[0].value}%</b>`,
        },
        series: [{
          data,
          type: 'line',
          smooth: true,
          lineStyle: { color: '#409eff', width: 2 },
          itemStyle: { color: '#409eff' },
          symbol: 'circle',
          symbolSize: 6,
        }],
      });
    },
    handleContinueOrRedo() {
      if (this.paperInfo.canContinue) {
        this.$router.push({ path: '/main/freeStudyPaper', query: { paperId: this.paperId, courseId: this.courseId, mode: 'answer' } });
        return;
      }
      this.$confirm('确定要开始重新练习吗？', '重新练习', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/startRedo', { paperId: this.paperId, courseId: this.courseId }).then(() => {
          this.$router.push({ path: '/main/freeStudyPaper', query: { paperId: this.paperId, courseId: this.courseId, mode: 'answer' } });
        });
      }).catch(() => {});
    },
    openReview(record) {
      this.reviewRecord = record;
      this.reviewCurrentIdx = 0;
      this.$http.get('/student/pc/freeStudy/paperRecordDetail', { recordId: record.id }).then(res => {
        const sections = res.sections || [];
        let globalIndex = 0;
        sections.forEach(section => {
          section.questions = (section.questions || []).map(q => {
            globalIndex++;
            // 保留题干 HTML（含图片），仅替换填空占位符
            let content = q.content || q.title || '';
            if (q.type === 'BLANKFILL') {
              content = content.replace(/\[BlankArea\d+\]/g, '______');
            }
            return {
              ...q,
              globalIndex,
              content: this.reformHtml(content),
              analysis: this.reformHtml(q.analysis || ''),
              options: (q.options || []).map(opt => ({
                ...opt,
                text: this.reformHtml(opt.text || ''),
              })),
            };
          });
        });
        this.reviewSections = sections;
        this.reviewVisible = true;
      });
    },
    deleteRecord(record, idx) {
      this.$confirm('确定要删除这条练习记录吗？此操作不可恢复。', '删除记录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/deleteRecord', { recordId: record.id }).then(() => {
          this.$message.success('删除成功');
          this.getRecordList();
          this.getSummary();
          this.getTrend();
        });
      }).catch(() => {});
    },
    sectionTitle(section, si) {
      return _sectionTitle(section, si);
    },
    // 富文本图片自适应宽度，避免撑破布局
    reformHtml(html) {
      if (!html) return '';
      return String(html).replace(/<img/gi, '<img style="max-width:100%;"');
    },
    getReviewOptionClass(q, val) {
      if (q.type === 'MULTIPLECHOICE') {
        const isAnswer = q.answer && q.answer.includes(val);
        const isUser = q.userAnswer && q.userAnswer.includes(val);
        if (isAnswer) return { correct: true };
        if (isUser && !isAnswer) return { wrong: true };
        return {};
      }
      if (val === q.answer) return { correct: true };
      if (val === q.userAnswer && val !== q.answer) return { wrong: true };
      return {};
    },
    formatUserAnswer(q) {
      if (q.type === 'JUDGMENT') {
        return q.userAnswer === 'Y' ? '正确' : '错误';
      }
      if (q.type === 'BLANKFILL') {
        const ans = q.userAnswer || '';
        return ans.includes('`') ? ans.split('`').join('、') : (ans || '未作答');
      }
      if (Array.isArray(q.userAnswer)) return q.userAnswer.join('');
      return q.userAnswer || '';
    },
    getBlankRows(q) {
      const blanks = q.blanks || [];
      const userAns = q.userAnswer || '';
      const userParts = userAns.includes('`') ? userAns.split('`') : (userAns ? [userAns] : []);
      return blanks.map((b, i) => ({
        correct: this.reformHtml(b.value || ''),
        user: userParts[i] || '',
        isCorrect: (userParts[i] || '').trim() === (b.value || '').trim(),
      }));
    },
    hasUserAnswer(q) {
      if (Array.isArray(q.userAnswer)) return q.userAnswer.some(v => v !== '');
      return !!q.userAnswer;
    },
    goReviewQuestion(idx) {
      this.reviewCurrentIdx = idx;
      const q = this.reviewFlatQuestions[idx];
      if (q) {
        const ref = this.$refs['reviewQ_' + q.globalIndex];
        const el = ref && (Array.isArray(ref) ? ref[0] : ref);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    formatDuration(seconds) {
      return Math.ceil(seconds / 60);
    },
    recordTotal(record) {
      if (record.totalCount != null) return record.totalCount;
      return (record.correctCount || 0) + (record.wrongCount || 0);
    },
    rateColorClass(rate) {
      return Number(rate) >= 60 ? 'correct' : 'wrong';
    },
    openWrongModal() {
      this.wrongVisible = true;
    },
    openFavModal() {
      this.favVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.free-study-page { min-height: 639px;box-shadow: none;background: transparent; }
.content-wrap {
  width: 100%;
  overflow: hidden;
}
.paper-header {
  display: flex; justify-content: space-between; align-items: center;
  background: #fff; border-radius: 12px; padding: 18px 24px; margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  .paper-name { font-size: 18px; font-weight: bold; color: #333; margin-bottom: 8px; }
  .paper-meta { font-size: 13px; color: #666; display: flex; gap: 30px; }
  .redo-btn {
    flex-shrink: 0;
    display: inline-flex; align-items: center; padding: 6px 18px; border-radius: 18px;
    background: #fff; color: $primary-dark; font-size: 13px; border: 1px solid $primary-dark;
    cursor: pointer; text-decoration: none; transition: all .2s;
    &:hover { background: $primary-light; }
  }
}
.section-title {
  display: flex; align-items: center; font-size: 16px; font-weight: bold; color: #333; margin: 0 0 16px;
  .title-bar {
    width: 4px; height: 16px; border-radius: 2px; background: $primary; margin-right: 8px; flex-shrink: 0;
  }
  .sub { font-size: 13px; color: #999; font-weight: normal; margin-left: 4px; }
}
.panel {
  background: #fff; border-radius: 12px; padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  height: 280px;
}
.dashboard-top {
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; align-items: stretch;
}
.stats-panel {
  display: flex; flex-direction: column;
}
.metric-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 16px;
}
.metric-box {
  border-radius: 8px; padding: 14px 8px; text-align: center; background: #fff;
  .metric-label { font-size: 13px; color: #666; margin-bottom: 8px; }
  .metric-value { font-size: 20px; font-weight: 500; }
  &.blue { border: 1px solid #b3d4ec;background: linear-gradient( 180deg, #E5EEFF 0%, #FFFFFF 83.57%); .metric-value { color: $primary-dark; } }
  &.green { border: 1px solid #c2e7b0;background: linear-gradient( 180deg, #ECFFEC 0%, #FFFFFF 83.57%); .metric-value { color: $success; } }
  &.orange { border: 1px solid #f5d89a;background: linear-gradient( 180deg, #FFF7E3 0%, #FFFFFF 83.57%); .metric-value { color: $accent; } }
  &.red { border: 1px solid #fbc4c4;background: linear-gradient( 180deg, #FFE6E3 0%, #FFFFFF 83.57%); .metric-value { color: $danger; } }
}
.entry-row {
  display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: auto;
}
.entry-card {
  position: relative; display: flex; align-items: center; justify-content: space-between;
  height: 75px; padding: 14px 16px; border-radius: 10px; cursor: pointer; overflow: hidden;
  transition: transform .2s, box-shadow .2s;
  &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); }
  &.wrong-entry { background: linear-gradient(135deg, #fff5f5 0%, #ffecec 100%); }
  &.fav-entry { background: linear-gradient(135deg, #fffbf0 0%, #fff3d6 100%); }
  .entry-title {
    display: flex; align-items: center; gap: 6px; font-size: 15px; font-weight: bold; color: #4D0000; margin-bottom: 6px;
  }
  .entry-sub { font-size: 13px; color: #999; }
  .entry-img { width: 100%; height: 75px; flex-shrink: 0; object-fit: contain;position: absolute;top: 0;left: 0;}
}
.entry-arrow {
  display: inline-block; width: 14px; height: 14px;
}
.chart-panel {
  display: flex; flex-direction: column;
  .trend-chart { flex: 1; min-height: 200px; }
}
.record-panel {
  height: auto;
  .record-list-header {
    display: flex; align-items: center;
    .section-title{margin-bottom: 0;}
    .subtitle { font-size: 13px; color: #999; padding-left: 12px; }
  }
  .record-list-body {
    max-height: 500px;
    overflow-y: auto;
  }
}
.record-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 18px 0; margin: 0 24px; border-bottom: 1px solid #f0f0f0;
  transition: background .2s; cursor: pointer;
  &:last-child { border-bottom: none; }
  &:hover { background: #fafafa; margin-left: 0; margin-right: 0; padding-left: 24px; padding-right: 24px; }
  .record-main { flex: 1; min-width: 0; }
  .record-datetime { font-size: 15px; font-weight: bold; color: #333; margin-bottom: 10px; }
  .record-stats {
    display: flex; flex-wrap: wrap; gap: 8px 24px; font-size: 13px; color: #666;
    >span{min-width: 100px;}
    .val { font-weight: bold; }
    .val.correct { color: $success; }
    .val.wrong { color: $danger; }
  }
  .record-action {
    flex-shrink: 0; margin-left: 24px; white-space: nowrap;
    .action-btn {
      display: inline-flex; align-items: center; padding: 4px 20px; border-radius: 18px;
      background: #fff; color: $primary-dark; font-size: 13px; border: 1px solid $primary-dark;
      cursor: pointer; transition: all .2s;
      &:hover { background: $primary-light; }
      &.delete { border-color: $danger; color: $danger; margin-left: 10px; }
      &.delete:hover { background: #fef0f0; }
    }
  }
}
.empty-state { text-align: center; padding: 60px 0; color: #999; font-size: 14px; .icon { font-size: 48px; margin-bottom: 16px; color: #ddd; } }
.review-stats {
  display: flex; gap: 20px; margin-bottom: 20px;
  .review-stat {
    flex: 1; padding: 16px; background: #f9f9f9; border-radius: 8px; text-align: center;
    .stat-value { font-size: 24px; font-weight: bold; color: $primary-dark; }
    .stat-value.correct { color: #67c23a; }
    .stat-value.wrong { color: #f56c6c; }
    .stat-label { font-size: 12px; color: #999; margin-top: 4px; }
  }
}
.review-questions { display: flex; gap: 16px; }
.review-main { flex: 1; }
.review-sidebar { width: 200px; flex-shrink: 0; }
.review-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e3e3e3;
  .card-title { font-size: 14px; font-weight: bold; color: #333; margin-bottom: 12px; }
}
.review-grid {
  display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px;
  .num {
    width: 24px; height: 24px; border-radius: 4px; display: flex; align-items: center; justify-content: center;
    font-size: 11px; cursor: pointer; transition: all .2s;
    &.correct { background: #f0f9eb; color: #67c23a; border: 1px solid #67c23a; }
    &.wrong { background: #fef0f0; color: #f56c6c; border: 1px solid #f56c6c; }
    &.answered { background: $primary-light; color: $primary-dark; border: 1px solid $primary-dark; }
    &.current { box-shadow: 0 0 0 2px $primary-dark; }
  }
}
.review-legend {
  display: flex; gap: 12px; margin-top: 12px; font-size: 11px; color: #999; justify-content: center;
  span { display: flex; align-items: center; gap: 4px; }
  .dot { width: 12px; height: 12px; border-radius: 3px; }
  .dot.correct { background: #f0f9eb; border: 1px solid #67c23a; }
  .dot.wrong { background: #fef0f0; border: 1px solid #f56c6c; }
}
.question-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e3e3e3; margin-bottom: 16px;
}
.q-section-title { font-size: 14px; font-weight: bold; color: #333; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 1px solid #f2f2f2; }
.q-item { margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px dashed #eee; &:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; } }
.q-num-tag {
  font-size: 14px; color: #333; font-weight: bold; margin-bottom: 10px; line-height: 1.6;
  ::v-deep img { max-width: 100%; height: auto; display: block; margin: 8px 0; }
}
.q-options {
  list-style: none; padding: 0;
  li {
    padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3;
    font-size: 14px; display: flex; align-items: center; gap: 8px;
    .radio { width: 16px; height: 16px; border-radius: 50%; border: 2px solid #ccc; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    &.correct { border-color: #67c23a; background: #f0f9eb; .radio { border-color: #67c23a; background: #67c23a; &::after { content: '\2713'; color: #fff; font-size: 10px; line-height: 1; } } }
    &.wrong { border-color: #f56c6c; background: #fef0f0; .radio { border-color: #f56c6c; &::after { content: '\2717'; color: #f56c6c; font-size: 10px; line-height: 1; } } }
    ::v-deep img { max-width: 100%; height: auto; }
  }
}
.analysis-box {
  background: #f9f9f9; border-radius: 8px; padding: 14px 18px; margin-top: 12px; border-left: 3px solid $primary-dark;
  .label { font-size: 13px; color: $primary-dark; font-weight: bold;}
  .answer { font-size: 13px; color: #333; .text-correct { color: #67c23a; } .text-wrong { color: #f56c6c; } }
  .blank-row { margin-bottom: 2px; }
  .detail {
    font-size: 13px; color: #666; line-height: 1.8;
    flex: 1;
    ::v-deep img { max-width: 100%; height: auto; display: block; margin: 8px 0; }
  }
  .answer-html {
    ::v-deep img { max-width: 100%; height: auto; display: block; margin: 8px 0; }
  }
  .answer-box{
    margin-bottom: 10px;
    line-height: 1.8;
  }
}
// 自定义弹窗通用样式
.custom-modal-mask {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.5);
  z-index: 2000; display: flex; align-items: flex-start; justify-content: center; padding-top: 8vh;
  overflow-y: auto;
}
.custom-modal {
  background: #fff; border-radius: 10px; border: 1px solid #e3e3e3; box-shadow: 0 4px 20px rgba(0,0,0,.15);
  max-height: 84vh; display: flex; flex-direction: column;
}
.custom-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 24px; background: $primary-light; border-bottom: 1px solid $primary-border; border-radius: 10px 10px 0 0; flex-shrink: 0;
  .modal-title { font-size: 15px; font-weight: bold; color: #333; }
  .count { font-size: 13px; font-weight: normal; color: #999; margin-left: 8px; }
}
.custom-modal-close {
  font-size: 22px; color: #999; cursor: pointer; line-height: 1; padding: 0 4px;
  &:hover { color: #333; }
}
.custom-modal-body {
  flex: 1; overflow-y: auto; padding: 20px 24px;
}
.orange { color: #FF8F1F;}
</style>
